import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material';
import { DomSanitizer } from '@angular/platform-browser';
import { Lightbox } from 'ngx-lightbox';
import { Patient } from '../../../../core/models/patient/patient';
import { PatientInsuranceDetail } from '../../../../core/models/patient/patientInsuranceDetail';
import { PatientService } from '../../../../core/services/v2/patient.service';
import { UtilsService } from '../../../../core/services/v2/utils.service';
import { PatientInsuranceDialogComponent } from '../../../../physician/patient/physician-patient-profile/patient-insurance-dialog/patient-insurance-dialog.component';
import { PhysicianOptionService } from '../../../../physician/shared/physician-option/physician-option.service';
import { WindowLoaderService } from '../../../../shared/components/window-loader/window-loader.service';

@Component({
  selector: 'app-patient-insurance',
  templateUrl: './patient-insurance.component.html',
  styleUrls: ['./patient-insurance.component.scss']
})
export class PatientInsuranceComponent implements OnInit {
  isEdit = false;

  @Input() patientProfile: Patient;
  @Input() editEnable: boolean = true;
  @Input() patientInsurances: PatientInsuranceDetail[];
  @Input() isParams = false;
  @Input() patientId: string;
  @Output() toggleEditEvent = new EventEmitter();
  private previewBoxDialogBox: MatDialogRef<TemplateRef<any>>;
  @ViewChild('previewBox', { static: false }) previewBox: TemplateRef<any>;
  patientInsurance: PatientInsuranceDetail;
  insuranceCatAr = [

    { itemValue: "1", itemDescription: "Medical" },

    { itemValue: "2", itemDescription: "Dental" },

    { itemValue: "3", itemDescription: "Vision" },

  ];
  constructor(private lightbox: Lightbox,
    public dialog: MatDialog,
    private sanitizer: DomSanitizer,
    private loaderService: WindowLoaderService,
    private patientService: PatientService,
    private changeDetectorRefs: ChangeDetectorRef,
    private physicianOptionService: PhysicianOptionService,
    private _utils: UtilsService
  ) { }

  ngOnInit() {
  }

  toggleEdit(patientInsurance: PatientInsuranceDetail) {
    if (patientInsurance) {
      this.toggleEditEvent.emit(patientInsurance);
    } else {
      this.toggleEditEvent.emit(new PatientInsuranceDetail());
    }
  }

  previewInsurance(patientInsurance: PatientInsuranceDetail): void {
    this.patientInsurance = patientInsurance;
    this.previewBoxDialogBox = this.dialog.open(this.previewBox, {
      panelClass: `dialog--popup`,
      width: '800px',
      disableClose: false,
    });

  }

  closeDialogBox() {
    this.previewBoxDialogBox.close();
  }

  getInsuranceCategory(category: number) {
    let ins = this.insuranceCatAr.find(x => x.itemValue == category.toString())
    return ins ? ins.itemDescription : '';
  }

  deletePatientInsurance(patientInsuranceId: number, ind: number) {
    this.loaderService.blockWithLoader(this.patientService.deletePatientInsurance(patientInsuranceId))
      .subscribe(
        (res) => {
          if (res.isSuccess) {
            this.patientInsurances.splice(ind, 1);
          } else
            console.error(res);
        },
        (error) => { console.error(error); }
      );

  }

  //openBenefitsDialog(insuranceId: number) {

  //const dialogRef = this.dialog.open(PatientInsuranceDialogComponent, {
  //  maxWidth: "90vw",
  //  maxHeight: "90vh",
  //  height: "90%",
  //  width: "90%",
  //  id: "dialogInsurance",
  //  data: {
  //    patient: this.patientProfile,
  //    physiciannpi: this.physicianOptionService.getPhysician() ? this.physicianOptionService.getPhysician().npi : null,
  //    insuranceId: insuranceId
  //  },
  //});
  //}

  getBenefitsDialogData(insuranceId: number) {
    const physiciannpi = this.physicianOptionService.getPhysician() ? this.physicianOptionService.getPhysician().npi : null;
    this.loaderService.blockWithLoader(this.patientService.getBenefitsFromAvaility(this.patientProfile.id, physiciannpi, false, insuranceId)).subscribe(
      (pinsurance) => {
        console.log(pinsurance);
        try {
          if (pinsurance.resultStatus.isSuccess && pinsurance.resultStatus.errorCode == 0) {
            const pinsuranceInfo = pinsurance.result.availityCoverageResponse;
            this.openBenefitsDialog(insuranceId, pinsuranceInfo);
          } else {
            if (pinsurance.resultStatus.errorCode == 202 || pinsurance.resultStatus.errorCode == 204) {
              this._utils.showMessageSnackBar("Please click on refresh button", true);
            }
            else if (pinsurance.resultStatus.errorCode == 1000) {
              this._utils.showMessageSnackBar(pinsurance.resultStatus.message, true);
            }
            else if (pinsurance.resultStatus.errorCode == 400) {
              this._utils.showMessageSnackBar(pinsurance.resultStatus.message, true);
            }
            else if (pinsurance.resultStatus.errorCode == 429) {
              this._utils.showMessageSnackBar("Please after some time", true);
            } else {
              this._utils.showMessageSnackBar("Unable to get coverage details", true);
            }
          }
        } catch (e) {
          this._utils.showMessageSnackBar(e, true);
        }
      },
      (error) => {
        console.error(error);
        this.loaderService.hide();
      }
    );
  }

  openBenefitsDialog(insuranceId: number, pinsuranceInfo: any) {
    const dialogRef = this.dialog.open(PatientInsuranceDialogComponent, {
      maxWidth: "90vw",
      maxHeight: "90vh",
      height: "90%",
      width: "90%",
      id: "dialogInsurance",
      data: {
        patient: this.patientProfile,
        physiciannpi: this.physicianOptionService.getPhysician() ? this.physicianOptionService.getPhysician().npi : null,
        insuranceId: insuranceId,
        pinsuranceInfo: pinsuranceInfo
      },
    });
  }
}
